/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Set color</h4>

<p>Set the color for the selected faces, or for all faces if none are selected.</p>`;

export default function ShowColorsTooltip() {
    return h('div', { innerHTML: body });
}
